import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

// Suppress PostHog recorder errors that crash the error overlay
const originalError = window.onerror;
window.onerror = function(msg, src, line, col, err) {
  if (src && src.includes('posthog')) return true;
  if (msg && msg.includes('nodeType')) return true;
  if (originalError) return originalError(msg, src, line, col, err);
  return false;
};

// Remove CRA error overlay when caused by third-party scripts
const observer = new MutationObserver((mutations) => {
  for (const m of mutations) {
    for (const node of m.addedNodes) {
      if (node.tagName === 'IFRAME' && node.id === 'webpack-dev-server-client-overlay') {
        node.remove();
      }
    }
  }
});
observer.observe(document.body || document.documentElement, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register();
